<button
  id="order-update-button"
  mat-icon-button
  [disabled]="isUpdateInPending"
  [matTooltip]="isUpdateInPending ? pendingUpdateIconData.toolTip : 'Update'"
>
  <span class="material-icons-outlined" (click)="openDialog()">
    edit_note
  </span>
  @if (isUpdateInPending) {
  <span class="mat-circle material-icons-round">
    {{ pendingUpdateIconData.badgeIcon }}
  </span>
  }
</button>
